import GenericSidebarHeader from '../../components/layout/Sidebar/GenericSidebarHeader';
import { useFlag } from '@unleash/proxy-client-react';
import { Icons } from 'greener-ui-library';
import useAuth from 'hooks/useAuth';
import { useSidebarItems } from 'hooks/useSidebarItems';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import {
  canCreateAsset,
  canCreateDeviceModel,
  canCreateEye,
  canCreateOrganisation,
  canCreateUser,
  canCreateUserRoles,
  canCreateWatcherType,
  canSeeFleets,
} from 'utils/authorization';

export const useManagementSidebar = () => {
  const { t } = useTranslation();
  const { user } = useAuth();
  const isFleetsEnabled = useFlag('fleets');
  const { dispatchSidebar } = useSidebarItems();

  useEffect(() => {
    const sidebarConfig = [
      {
        name: t('navigation.profile'),
        path: '/account',
        icon: Icons.User,
        isVisible: true,
      },
      {
        name: t('entities:organisation.myOrganisations'),
        path: '/my-organisations',
        icon: Icons.Organisation,
        isVisible: true,
      },
      {
        name: t('entities:user.namePlural'),
        path: '/users',
        icon: Icons.Users,
        isVisible: canCreateUser(user?.role),
      },
      {
        name: t('entities:userRole.namePlural'),
        path: '/user-roles',
        icon: Icons.Role,
        isVisible: canCreateUserRoles(user?.role),
      },
      {
        name: t('entities:organisation.namePlural'),
        path: '/organisations',
        icon: Icons.Organisation,
        isVisible: canCreateOrganisation(user?.role),
      },
      {
        name: t('entities:greenerUnit.namePlural'),
        path: '/greener-units',
        icon: Icons.Unit,
        isVisible: canCreateAsset(user?.role),
      },
      {
        name: t('entities:fleet.namePlural'),
        path: '/fleets',
        icon: Icons.ViewCompact,
        isVisible: canSeeFleets(user?.role) && isFleetsEnabled,
      },
      {
        name: t('entities:greenerEye.namePlural'),
        path: '/greener-eyes',
        icon: Icons.GreenerEye,
        isVisible: canCreateEye(user?.role),
      },
      {
        name: t('entities:watcherType.namePlural'),
        path: '/watcher-types',
        icon: Icons.WatcherType,
        isVisible: canCreateWatcherType(user?.role),
      },
      {
        name: t('entities:deviceModel.namePlural'),
        path: '/device-models',
        icon: Icons.Devices,
        isVisible: canCreateDeviceModel(user?.role),
      },
    ];

    if (dispatchSidebar) {
      dispatchSidebar({
        type: 'REGULAR',
        payload: {
          items: sidebarConfig.filter((i) => i.isVisible),
          sidebarHeader: <GenericSidebarHeader title={t('entities:domain')} />,
        },
      });
    }
  }, [user, dispatchSidebar, t]);
};
